import { Helmet } from "react-helmet";
import pdf from '../../assets/images/pdf.webp'
import IPPoE from '../../assets/images/products__IP-PoE.webp';
import APM from '../../assets/images/products__APM.webp';
import Polycamera from '../../assets/images/products-polycamera.webp';
import Recorder from '../../assets/images/test-drive-recorder.webp';


import './products.scss';
import { useTranslation } from "react-i18next";

const Products: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className="products">
            <Helmet>
                <title>Продукты - Видеонаблюдение и Безопасность</title>
                <meta name="description" content="Наши продукты: мультифокальные камеры, IP видеодекодеры, IP PoE микрофоны. Закажите и купите камеры у нас." />
                <meta name="keywords" content="Мультифокальные камеры, IP видеодекодер для видеостены, IP PoE микрофон, Заказать камеры, Купить камеры" />
            </Helmet>
            <div className="Polycamera" id='Polycamera'>
                <h2 className="products__header">{t("products_section.title")}</h2>
                <div className="product">
                    <div className="product__header">
                        <h3 className="product__text-h3">{t("products_section.products.polycamera.name")}</h3>
                        <p className="product__text-p">{t("products_section.products.polycamera.description")}</p>
                    </div>

                    <div className="product__about">
                        <div className="product__about-photo">
                            <img src={Polycamera} alt="Camera Polycamera" />
                            <p>{t("products_section.products.polycamera.about")}</p>
                        </div>
                        <div className="product__about-text">
                            <ul>
                                <li>
                                    <h4>{t("products_section.products.polycamera.features.feature1.title")}</h4>
                                    <p>{t("products_section.products.polycamera.features.feature1.description")}</p>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.polycamera.features.feature2.title")}</h4>
                                    <p>{t("products_section.products.polycamera.features.feature2.description")}</p>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.polycamera.features.feature3.title")}</h4>
                                    <p>{t("products_section.products.polycamera.features.feature3.description")}</p>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.polycamera.features.feature4.title")}</h4>
                                    <p>{t("products_section.products.polycamera.features.feature4.description")}</p>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.polycamera.features.feature5.title")}</h4>
                                    <p>{t("products_section.products.polycamera.features.feature5.description")}</p>
                                </li>
                                <li className='link-to-pdf'>
                                    <a href={require('./Polycamera.pdf')} download="Polycamera" target="_blank" rel="noreferrer">
                                        <img src={pdf} alt="icon pdf" />
                                        <p>{t("products_section.products.polycamera.pdf_link")}</p>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="IP-PoE" id='IP-PoE'>
                <div className="product">
                    <div className="product__header">
                        <h3 className="product__text-h3">{t("products_section.products.ip_poe_microphone.name")}</h3>
                        <p className="product__text-p">{t("products_section.products.ip_poe_microphone.description")}</p>
                    </div>

                    <div className="product__about">
                        <div className="product__about-photo">
                            <img src={IPPoE} alt="microphone IP-PoE" />
                            <p>{t("products_section.products.ip_poe_microphone.about")}</p>
                        </div>
                        <div className="product__about-text">
                            <ul>
                                <li>
                                    <h4>{t("products_section.products.ip_poe_microphone.features.feature1.title")}</h4>
                                    <p>{t("products_section.products.ip_poe_microphone.features.feature1.description")}</p>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.ip_poe_microphone.features.feature2.title")}</h4>
                                    <p>{t("products_section.products.ip_poe_microphone.features.feature2.description")}</p>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.ip_poe_microphone.features.feature3.title")}</h4>
                                    <p>{t("products_section.products.ip_poe_microphone.features.feature3.description")}</p>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.ip_poe_microphone.features.feature4.title")}</h4>
                                    <p>{t("products_section.products.ip_poe_microphone.features.feature4.description")}</p>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.ip_poe_microphone.features.feature5.title")}</h4>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.ip_poe_microphone.features.feature6.title")}</h4>
                                    <p>{t("products_section.products.ip_poe_microphone.features.feature6.description")}</p>
                                </li>
                                <li className='link-to-pdf'>
                                    <a href={require('./ds_Mic_PoE_RSS_Omni.pdf')} download="IP-PoE-Microphone" target="_blank" rel="noreferrer">
                                        <img src={pdf} alt="icon pdf" />
                                        <p>{t("products_section.products.ip_poe_microphone.pdf_link")}</p>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="IP-decoder" id='IP-decoder'>
                <div className="product">
                    <div className="product__header">
                        <h3 className="product__text-h3">{t("products_section.products.rss_10000.name")}</h3>
                        <p className="product__text-p">{t("products_section.products.rss_10000.description")}</p>
                    </div>

                    <div className="product__about">
                        <div className="product__about-photo">
                            <img src={Recorder} alt="IP video-decoder" />
                            <p>{t("products_section.products.rss_10000.about")}
                            </p>
                        </div>
                        <div className="product__about-text">
                            <ul>
                                <li>
                                    <h4>{t("products_section.products.rss_10000.features.feature1.title")}</h4>
                                    <p>{t("products_section.products.rss_10000.features.feature1.description")}</p>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.rss_10000.features.feature2.title")}</h4>
                                    <p>{t("products_section.products.rss_10000.features.feature2.description")}</p>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.rss_10000.features.feature3.title")}</h4>
                                    <p>{t("products_section.products.rss_10000.features.feature3.description")}</p>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.rss_10000.features.feature4.title")}</h4>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.rss_10000.features.feature5.title")}</h4>
                                    <p>{t("products_section.products.rss_10000.features.feature5.description")}</p>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.rss_10000.features.feature6.title")}</h4>
                                    <p>{t("products_section.products.rss_10000.features.feature6.description")}</p>
                                </li>
                                <li className='link-to-pdf'>
                                    <a href={require('./RSS-10000.pdf')} download="RSS-10000" target="_blank" rel="noreferrer">
                                        <img src={pdf} alt="icon pdf" />
                                        <p>{t("products_section.products.rss_10000.pdf_link")}</p>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="APM" id='APM'>
                <div className="product">
                    <div className="product__header">
                        <h3 className="product__text-h3">{t("products_section.products.apm_station.name")}</h3>
                        <p className="product__text-p">{t("products_section.products.apm_station.description")}</p>
                    </div>

                    <div className="product__about">
                        <div className="product__about-photo">
                            <img src={APM} alt="APM camera" />
                            <p>{t("products_section.products.apm_station.about")}.</p>
                        </div>
                        <div className="product__about-text">
                            <ul>
                                <li>
                                    <h4>{t("products_section.products.apm_station.features.feature1.title")}</h4>
                                    <p>{t("products_section.products.apm_station.features.feature1.description")}</p>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.apm_station.features.feature2.title")}</h4>

                                </li>
                                <li>
                                    <h4>{t("products_section.products.apm_station.features.feature3.title")}</h4>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.apm_station.features.feature4.title")} </h4>
                                </li>
                                <li>
                                    <h4>{t("products_section.products.apm_station.features.feature5.title")}</h4>
                                    <p>{t("products_section.products.apm_station.features.feature5.description")}</p>
                                </li>
                                <li className='link-to-pdf'>
                                    <a href={require('./APM.pdf')} download="APM" target="_blank" rel="noreferrer">
                                        <img src={pdf} alt="icon pdf" />
                                        <p>{t("products_section.products.apm_station.pdf_link")}</p>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Products;